import { render, staticRenderFns } from "./PopupInvoice.vue?vue&type=template&id=42988f32&scoped=true"
import script from "./PopupInvoice.vue?vue&type=script&lang=js"
export * from "./PopupInvoice.vue?vue&type=script&lang=js"
import style0 from "./PopupInvoice.vue?vue&type=style&index=0&id=42988f32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42988f32",
  null
  
)

export default component.exports